module.exports = __webpack_public_path__ + "img/origami_saturdays.3b0c6c0d.jpg";